import React, { Component } from 'react';

export default class LdapServerAdditionalDetails extends Component {

    shouldComponentUpdate(nextProps) {
        
        if (nextProps.directoryType != this.props.directoryType
                || nextProps.baseDn != this.props.baseDn
                || nextProps.synchronizationEnabled != this.props.synchronizationEnabled) {
         
                return true;
        }

        return false;
    }

    render() {

        return(
            <div className='additional-details'>
                <div>
                    <div>{this.props.translations.directoryType}:</div>
                    <div>{this.props.translations.baseDn}:</div>
                    <div>{this.props.translations.synchronization}:</div>
                </div>
                <div className='right'>
                    <div className='ellipsis ldap-dir-type' title={this.props.directoryType}>
                        {this.props.directoryType}
                    </div>
                    <div className='ellipsis ldap-base-dn' title={this.props.baseDn}>
                        {this.props.baseDn}
                    </div>
                    <div className='ellipsis ldap-synchronization'>
                        {this.props.synchronizationEnabled ? 
                            this.props.translations.enabled
                                :
                                    this.props.translations.disabled}
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/ldapServerAdditionalDetails/index.jsx